<!-- ============================================================== -->
<!-- toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav float-start me-auto">
  <li class="nav-item d-none d-lg-block">
    <a (click)="toggleSidebar.emit()" class="nav-link sidebartoggler waves-effect waves-light"
      href="javascript:void(0)">
      <i class="ti-menu"></i>
    </a>
  </li>
  <div *ngIf="!production" class="col-md-12" style="margin-top: 18px">
    <h2 style="color: black !important; margin-bottom: 0px; padding-bottom: 0px;">MÓDULO DE PRUEBA
    </h2>
  </div>
</ul>

<!-- ============================================================== -->
<!-- Right side toggle and nav items -->
<!-- ============================================================== -->
<div class="float-right">
  <div class="input-group">
    <div class="row">
      <div class="col-xl-4 col-lg-4 col-md-6 mt-3">
        <button type="button" class="btn btn-light font-weight-bold btn-rounded text-nowrap"
          (click)="abrirModalEstadoCuentaCliente()">
          <img src="./../../../favicon.ico" style="height: 22px;"> Deuda pendientes a Grupo TSI</button>
      </div>
    </div>

    <ul class="navbar-nav float-end">
      <li class="nav-item dropdown" ngbDropdown placement="bottom-end">
        <!-- <a
      ngbDropdownToggle
      class="nav-link dropdown-toggle"
      href="javascript:void(0)"
      id="navbarDropdown"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <i class="flag-icon flag-icon-{{ selectedLanguage.icon }}"></i>
    </a> -->
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown" ngbDropdownMenu>
          <span class="dropdown-item" href="#" *ngFor="let lang of languages" (click)="changeLanguage(lang)">
            <i class="flag-icon flag-icon-{{ lang.icon }}"></i>
            <span>{{ lang.language }}
              <span *ngIf="lang.type">({{ lang.type }})</span>
            </span>
          </span>
        </div>
      </li>


      <!-- ============================================================== -->
      <!-- Comment -->
      <!-- ============================================================== -->
      <li class="nav-item dropdown" ngbDropdown placement="bottom-end">
        <!-- <a
      ngbDropdownToggle
      class="nav-link dropdown-toggle waves-effect waves-dark"
      href="javascript:void(0)"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <i class="mdi mdi-message"></i>
      <div class="notify">
        <span class="heartbit"></span> <span class="point"></span>
      </div>
    </a> -->
        <div class="dropdown-menu mailbox dropdown-menu-end dropdown-menu-animate-up" ngbDropdownMenu>
          <span class="with-arrow">
            <span class="bg-primary"></span>
          </span>
          <ul class="list-style-none">
            <li>
              <div class="drop-title bg-primary text-white">
                <h4 class="mb-0 mt-1 text-white">4 New</h4>
                <span class="fw-light">Notifications</span>
              </div>
            </li>
            <li>
              <div class="message-center notifications" [perfectScrollbar]="config">
                <!-- Message -->
                <a href="javascript:void(0)" class="message-item border-bottom d-block text-decoration-none"
                  *ngFor="let notification of notifications">
                  <span class="btn btn-circle rounded-circle {{ notification.btn }}">
                    <i class="{{ notification.icon }}"></i>
                  </span>
                  <span class="mail-contnet d-inline-block w-75 ps-3 align-middle">
                    <h5 class="message-title">{{ notification.title }}</h5>
                    <span class="mail-desc fs-2 d-block text-muted text-truncate">{{
                      notification.subject
                      }}</span>
                    <span class="time fs-2 d-block text-muted text-truncate">{{
                      notification.time
                      }}</span>
                  </span>
                </a>
              </div>
            </li>
            <li class="border-top p-3 d-grid">
              <button class="btn btn-info">Check all notifications</button>
            </li>
          </ul>
        </div>
      </li>
      <!-- ============================================================== -->
      <!-- End Comment -->
      <!-- ============================================================== -->
      <!-- ============================================================== -->
      <!-- Messages -->
      <!-- ============================================================== -->
      <li class="nav-item dropdown" ngbDropdown placement="bottom-end">
        <!-- <a
      ngbDropdownToggle
      class="nav-link dropdown-toggle waves-effect waves-dark"
      href="javascript:void(0)"
      id="2"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <i class="mdi mdi-email"></i>
      <div class="notify">
        <span class="heartbit"></span> <span class="point"></span>
      </div>
    </a> -->
        <div class="dropdown-menu dropdown-menu-end mailbox dropdown-menu-animate-up" aria-labelledby="2"
          ngbDropdownMenu>
          <span class="with-arrow">
            <span class="bg-danger"></span>
          </span>
          <ul class="list-style-none">
            <li>
              <div class="drop-title text-white bg-danger">
                <h4 class="mb-0 mt-1 text-white">5 New</h4>
                <span class="fw-light">Messages</span>
              </div>
            </li>
            <li>
              <div class="message-center message-body" [perfectScrollbar]="config">
                <!-- Message -->
                <a href="javascript:void(0)" class="message-item border-bottom d-block text-decoration-none"
                  *ngFor="let mymessage of mymessages">
                  <span class="user-img position-relative d-inline-block">
                    <img src="{{ mymessage.useravatar }}" alt="user" class="rounded-circle" />
                    <span class="profile-status rounded-circle d-inline-block {{
                    mymessage.status
                  }} float-end"></span>
                  </span>
                  <span class="mail-contnet d-inline-block w-75 ps-3 align-middle">
                    <h5 class="message-title">{{ mymessage.from }}</h5>
                    <span class="mail-desc fs-2 d-block text-muted text-truncate">{{
                      mymessage.subject
                      }}</span>
                    <span class="time fs-2 d-block text-muted text-truncate">{{
                      mymessage.time
                      }}</span>
                  </span>
                </a>
              </div>
            </li>
            <li>
              <a class="
              text-center
              link
              d-flex
              align-items-center
              justify-content-center
            " href="javascript:void(0);">
                <b>See all e-Mails</b>
                <i class="fa fa-angle-right ms-1"></i>
              </a>
            </li>
          </ul>
        </div>
      </li>
      <!-- ============================================================== -->
      <!-- End Messages -->
      <!-- ============================================================== -->
      <!-- ============================================================== -->
      <!-- mega menu -->
      <!-- ============================================================== -->
      <li class="nav-item mega-dropdown" ngbDropdown [autoClose]="false">
        <!-- <a
      ngbDropdownToggle
      class="nav-link waves-effect waves-dark"
      href="javascript:void(0)"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <i class="mdi mdi-view-grid"></i>
    </a> -->
        <div class="dropdown-menu" ngbDropdownMenu>
          <div class="mega-dropdown-menu row">
            <div class="col-lg-3 col-xlg-2 mb-4">
              <h4 class="mb-4">CAROUSEL</h4>
              <!-- CAROUSEL -->
              <ngb-carousel class="carousel-dark">
                <ng-template ngbSlide>
                  <img src="assets/images/big/img1.jpg" class="img-fluid" alt="Random first slide" />
                </ng-template>
                <ng-template ngbSlide>
                  <img src="assets/images/big/img2.jpg" class="img-fluid" alt="Random second slide" />
                </ng-template>
                <ng-template ngbSlide>
                  <img src="assets/images/big/img3.jpg" class="img-fluid" alt="Random third slide" />
                </ng-template>
              </ngb-carousel>
              <!-- End CAROUSEL -->
            </div>
            <div class="col-lg-3 mb-4">
              <h4 class="mb-4">ACCORDION</h4>
              <!-- Accordian -->
              <ngb-accordion [closeOthers]="true" activeIds="static-1" class="accordion nav-accordion">
                <ngb-panel id="static-1" title="Simple">
                  <ng-template ngbPanelContent>
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid.
                  </ng-template>
                </ngb-panel>
                <ngb-panel id="static-2">
                  <ng-template ngbPanelTitle>
                    <span>&#9733; <b>Fancy</b> title &#9733;</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid.
                  </ng-template>
                </ngb-panel>
                <ngb-panel id="static-3" title="Disabled" [disabled]="true">
                  <ng-template ngbPanelContent>
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid.
                  </ng-template>
                </ngb-panel>
              </ngb-accordion>
            </div>
            <div class="col-lg-3 mb-4">
              <h4 class="mb-4">CONTACT US</h4>
              <!-- Contact -->
              <form>
                <div class="mb-3">
                  <input type="text" class="form-control" id="exampleInputname1" placeholder="Enter Name" />
                </div>
                <div class="mb-3">
                  <input type="email" class="form-control" placeholder="Enter email" />
                </div>
                <div class="mb-3">
                  <textarea class="form-control" id="exampleTextarea" rows="3" placeholder="Message"></textarea>
                </div>
                <button type="submit" class="btn btn-info">Submit</button>
              </form>
            </div>
            <div class="col-lg-3 col-xlg-4 mb-4">
              <h4 class="mb-4">List style</h4>
              <!-- List style -->
              <ul class="list-style-none">
                <li>
                  <a href="javascript:void(0)">
                    <i class="fa fa-check text-success"></i> You can give link</a>
                </li>
                <li>
                  <a href="javascript:void(0)">
                    <i class="fa fa-check text-success"></i> Give link</a>
                </li>
                <li>
                  <a href="javascript:void(0)">
                    <i class="fa fa-check text-success"></i> Another Give link</a>
                </li>
                <li>
                  <a href="javascript:void(0)">
                    <i class="fa fa-check text-success"></i> Forth link</a>
                </li>
                <li>
                  <a href="javascript:void(0)">
                    <i class="fa fa-check text-success"></i> Another fifth link</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </li>
      <!-- ============================================================== -->
      <!-- End mega menu -->
      <!-- ============================================================== -->
      <!-- ============================================================== -->
      <!-- User profile and search -->
      <!-- ============================================================== -->
      <!-- BUSQUEDA DE DOCUMENTOS -->
      <li class="nav-item" ngbDropdown>
        <a data-bs-toggle="tooltip" title="Búsqueda de documento" ngbDropdownToggle
          class="nav-link text-muted waves-effect waves-dark pro-pic" href="javascript:void(0)" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          <i class="fas fa-search fa-lg"></i>
        </a>

        <div ngbDropdownMenu>
          <a href="javascript:void(0)" class="dropdown-item" (click)="RouteDocumentoXNumint()">
            <div class="media">
              <div class="media-body">
                <h4 class="dropdown-item-title">
                  <i class="fas fa-search-alt" style="margin-right: .3rem">
                  </i>
                  Por Numint
                </h4>
              </div>
            </div>
          </a>
          <div class="dropdown-divider"></div>
          <a href="javascript:void(0)" class="dropdown-item" (click)="RouteDocumentoXSerieNumero()">
            <div class="media">
              <div class="media-body">
                <h4 class="dropdown-item-title">
                  <i class="fas fa-search-alt" style="margin-right: .3rem">
                  </i>
                  Por Serie-Número
                </h4>
              </div>
            </div>
          </a>
        </div>
      </li>
      <li class="nav-item" ngbDropdown>
        <a data-bs-toggle="tooltip" title="Mantenimiento" ngbDropdownToggle
          class="nav-link text-muted waves-effect waves-dark pro-pic" href="javascript:void(0)" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          <i class="fas fa-users fa-lg"></i>
        </a>

        <div ngbDropdownMenu>
          <a href="javascript:void(0)" class="dropdown-item" (click)="RouteClienteNuevo()">
            <div class="media">
              <div class="media-body">
                <h4 class="dropdown-item-title">
                  <i class="fas fa-user-alt" style="margin-right: .3rem">
                  </i>
                  Cliente
                </h4>
              </div>
            </div>
          </a>
          <div class="dropdown-divider"></div>
          <a href="javascript:void(0)" class="dropdown-item" (click)="RouteProveedorNuevo()">
            <div class="media">
              <div class="media-body">
                <h4 class="dropdown-item-title">
                  <i class="fas fa-user-alt" style="margin-right: .3rem">
                  </i>
                  Proveedor
                </h4>
              </div>
            </div>
          </a>
          <div class="dropdown-divider"></div>
          <a href="javascript:void(0)" class="dropdown-item" (click)="RouteArticuloNuevo()">
            <div class="media">
              <div class="media-body">
                <h4 class="dropdown-item-title">
                  <i class="fas fa-user-alt" style="margin-right: .3rem">
                  </i>
                  Artículo
                </h4>
              </div>
            </div>
          </a>
          <!-- <div class="dropdown-divider"></div>
      <a href="javascript:void(0)" class="dropdown-item" (click)="RoutePlanCuentasNuevo()">
        <div class="media">
          <div class="media-body">
            <h4 class="dropdown-item-title">
              <i class="fas fa-user-alt" style="margin-right: .3rem">
              </i>
              Plan de cuentas
            </h4>
          </div>
        </div>
      </a> -->
        </div>
      </li>




      <li class="nav-item" ngbDropdown placement="bottom-right">
        <a ngbDropdownToggle class="nav-link text-muted waves-effect waves-dark pro-pic" href="javascript:void(0)"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img src="assets/images/users/user1.jpg" alt="user" class="rounded-circle" width="31" />
        </a>
        <div class="dropdown-menu-right user-dd" ngbDropdownMenu>
          <!-- <div class="d-flex no-block align-items-center p-3 mb-2">
        <div class="">
          <img
            src="assets/images/users/user1.jpg"
            alt="user"
            class="rounded"
            width="70"
          />
        </div>
        <div class="ms-2">
          <h4 class="mb-0 fs-4">Steave Jobs</h4>
          <p class="text-muted mb-0 fs-2">varun@gmail.com</p>
          <a
            href="javascript:void(0)"
            class="btn btn-danger btn-rounded btn-sm mt-1"
            >View Profile</a
          >
        </div>
      </div>
      <a class="dropdown-item" href="javascript:void(0)">
        <i class="ti-user me-1 ms-1"></i> My Profile</a
      >
      <a class="dropdown-item" href="javascript:void(0)">
        <i class="ti-wallet me-1 ms-1"></i> My Balance</a
      >
      <a class="dropdown-item" href="javascript:void(0)">
        <i class="ti-email me-1 ms-1"></i> Inbox</a
      >
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" href="javascript:void(0)">
        <i class="ti-settings me-1 ms-1"></i> Account Setting</a
      > -->


          <div class="d-flex align-items-center" style="padding: 15px; font-size: 1.14rem;">{{ sessionInfo.nombres }}
          </div>

          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="javascript:void(0)" style="font-size: 1.14rem;"
            (click)="openModalPanelControlUsuario()"> Panel de control</a>

          <div class="dropdown-divider"></div>
          <a class="dropdown-item" (click)="logout()">
            <i class="fa fa-power-off me-1 ms-1"></i> Cerrar sesión</a>
        </div>
      </li>
      <!-- ============================================================== -->
      <!-- User profile and search -->
      <!-- ============================================================== -->
    </ul>
  </div>
</div>